<template>
    <div class="bill_addon clr">
        <standart
            title="Розпорядження"
            key="order_addon"
            v-bind:is_active_result=false
            v-bind:is_active_problem=false
            v-bind:is_active_title=false
        ></standart>
    </div>
</template>

<script>
import standart from '../standart.vue'

export default {
    name: "order",
    components: {
        standart,
    },
    data() {
        return {
            form: {
            
            },
        }
    },
    
    mounted() {
    
    },
    
    
    methods: {
    
    
    },
    
    computed: {
    
    },
    
}

</script>

<style scoped>

</style>
